import texture_ps from './files/texture.ps.glsl';
import texture_vs from './files/texture.vs.glsl';
import baseRender2D_vs from './files/baseRender2D.vs';
import baseRender2D_ps from './files/baseRender2D.fs';
import ColorGLSL from "../d2/files/Color.glsl";
import MathGLSL from "../d2/files/Math.glsl";
import Sprite2DFrag from './NewShader/Sprite2DFrag.glsl';
import Sprite2DVertex from './NewShader/Sprite2DVertex.glsl';
import OutputTransformGLSL from "./files/OutputTransform.glsl";
import { Shader3D, ShaderFeatureType } from "../../../RenderEngine/RenderShader/Shader3D";
import { SubShader } from "../../../RenderEngine/RenderShader/SubShader";
import { ShaderDataType } from "../../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
export class Shader2D {
    destroy() {
    }
    static __init__() {
        Shader3D.addInclude("Sprite2DFrag.glsl", Sprite2DFrag);
        Shader3D.addInclude("Sprite2DVertex.glsl", Sprite2DVertex);
        Shader3D.addInclude("Color.glsl", ColorGLSL);
        Shader3D.addInclude("Math.glsl", MathGLSL);
        Shader3D.addInclude("OutputTransform.glsl", OutputTransformGLSL);
        Shader2D.graphicsShader = Shader3D.add("Sprite2DTexture", false, false);
        Shader2D.graphicsShader.shaderType = ShaderFeatureType.D2_TextureSV;
        let subShader = new SubShader(Shader2D.graphicsAttribute, {}, {});
        Shader2D.graphicsShader.addSubShader(subShader);
        let pass = subShader.addShaderPass(texture_vs, texture_ps);
        Shader2D.render2DNodeShader = Shader3D.add("baseRender2D", false, false);
        Shader2D.render2DNodeShader.shaderType = ShaderFeatureType.D2_BaseRednerNode2D;
        subShader = new SubShader(Shader2D.Render2DNodeAttribute, {}, {});
        Shader2D.render2DNodeShader.addSubShader(subShader);
        subShader.addShaderPass(baseRender2D_vs, baseRender2D_ps);
    }
}
Shader2D.graphicsAttribute = {
    'a_posuv': [0, ShaderDataType.Vector4],
    'a_attribColor': [1, ShaderDataType.Vector4],
    'a_attribFlags': [2, ShaderDataType.Vector4],
    'a_customs': [3, ShaderDataType.Vector4]
};
Shader2D.Render2DNodeAttribute = {
    'a_position': [0, ShaderDataType.Vector4],
    'a_color': [1, ShaderDataType.Vector4],
    'a_uv': [2, ShaderDataType.Vector2]
};
